// src/firebase.js

// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

// Your web app's Firebase configuration (from dnd-seafood project)
const firebaseConfig = {
  apiKey: "AIzaSyBU13lHpJs-KYWg3DD9psrI0fXmCqlUx0k",
  authDomain: "dnd-seafood.firebaseapp.com",
  projectId: "dnd-seafood",
  storageBucket: "dnd-seafood.firebasestorage.app",
  messagingSenderId: "426867762171",
  appId: "1:426867762171:web:97a035d64911078d72e15e"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore (or other services you need)
export const db = getFirestore(app);
